/* Branch-only PDP behavior; Shopify's existing variant/cart handlers do the buying. */
(() => {
  if (window.giestoZaraProduct) return;
  window.giestoZaraProduct = true;
  const desktop = matchMedia('(min-width:1025px)');
  function mount(root) {
    if(root.dataset.zpReady) return;
    root.dataset.zpReady = 'true';
    for(const image of root.querySelectorAll('[data-zp-pairing-media] img')) {
      const frame=image.parentElement;
      const finish=()=>{frame.classList.remove('is-photo-loading');frame.classList.toggle('is-photo-ready',image.naturalWidth>0);};
      if(image.complete)finish();
      else {frame.classList.add('is-photo-loading');image.addEventListener('load',finish,{once:true});image.addEventListener('error',finish,{once:true});}
    }
    const sizes=[...root.querySelectorAll('.gap__option')];
    const buy=root.querySelector('.gap__buy');
    const add=buy?.querySelector('button[type=submit]');
    let confirmed=false;
    const close=()=>{sizes.forEach(s=>s.classList.remove('zp-size-open'));add?.setAttribute('aria-expanded','false');};
    if(add && sizes.length===1){
      add.setAttribute('aria-expanded','false');
      document.addEventListener('click',event=>{
        if(!desktop.matches || !root.contains(event.target))return;
        const option=event.target.closest('[data-gap-option]');
        if(option && option.closest('.zp-size-open') && !option.disabled){
          // Let the existing product element select/render the native variant first.
          setTimeout(()=>{close();confirmed=true;add.click();confirmed=false;},0);
          return;
        }
        if(!event.target.closest('.gap__buy button[type=submit]')||confirmed||add.disabled)return;
        event.preventDefault();event.stopImmediatePropagation();
        const open=!sizes[0].classList.contains('zp-size-open');close();
        if(open){sizes[0].style.setProperty('--zp-size-top',`${buy.offsetTop+buy.offsetHeight}px`);sizes[0].classList.add('zp-size-open');add.setAttribute('aria-expanded','true');sizes[0].querySelector('button:not(:disabled)')?.focus({preventScroll:true});}
      },true);
      document.addEventListener('click',event=>{if(!root.contains(event.target))close();});
      root.addEventListener('keydown',event=>{if(event.key==='Escape'){close();add.focus({preventScroll:true});}});
      desktop.addEventListener('change',close);
    }
    const zooms=new MutationObserver(()=>{
      if(!desktop.matches)return;
      for(const track of root.querySelectorAll('.gaa__zoom-track')){
        for(const image of [...track.children]){
          if(image.tagName!=='IMG')continue;
          const frame=document.createElement('div');frame.className='zp-zoom-frame';image.before(frame);frame.append(image);
        }
      }
    });
    zooms.observe(root,{childList:true,subtree:true});
  }
  const tr=document.documentElement.lang.startsWith('tr');
  const syncHeadings=()=>{for(const rail of document.querySelectorAll('.gar')){const heading=rail.querySelector('.gar__heading');if(!heading)continue;if(!heading.dataset.zpOriginal)heading.dataset.zpOriginal=heading.textContent;const text=desktop.matches?(rail.dataset.garSource==='pairings'?(tr?'Stilinizi tamamlayın':'Complete your look'):(tr?'İlginizi çekebilir':'You may also like')):heading.dataset.zpOriginal;if(heading.textContent!==text)heading.textContent=text;}};
  desktop.addEventListener('change',syncHeadings);
  const main=document.querySelector('#MainContent');if(main)new MutationObserver(syncHeadings).observe(main,{subtree:true,childList:true});
  syncHeadings();
  customElements.whenDefined('giesto-store-product').then(()=>document.querySelectorAll('.gap--zara-product').forEach(mount));
  document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.gap--zara-product').forEach(mount));
})();
